import { playLoadMoreAnimation } from './animation-load-more'
import { elementsToMaxHeight } from './utils/elements-to-max-height'
import { setupCursorEvent } from './cursor'
import { initGallerySlider } from './sections/news'
import { loadElementLazyImage } from './lazy-load'

let popup = $('.popup-learn-more')
let body = $('body')
let globalHash = window.location.hash
let lastHistory = '';
let hashTimeout = 0;


if (globalHash) {
  goToHash(globalHash)
}

if (window.location.href.search('post-open-')) {
  initGallerySlider(popup)
}



function closePopup()
{
  popup.removeClass('opened')

  $('html').removeClass('popup-open')
  setTimeout(function (e){
    popup.hide()
    popup.attr('data-type', '')
    popup.find('.load-content').html('')
    body.removeClass('popup-open')
  }, 800)

  lastHistory = 'clear'
  setUrl(openedPageUrl)
}

function openPopup(type, contentID, clickedOn) {

  if (type === 'post'){
    contentID = contentID.replace('post-popup-', '')

    $.ajax({
      url: directory + "/wp-admin/admin-ajax.php",
      type:'POST',
      data:'action=postPopup&id='+ contentID,
      success:function(results) {

        let content = $(results)
        popup.find('.js-load-content').html(content)
        initGallerySlider(popup)

      }
    });


  } else {

    let content = $('[data-content-id="' + contentID + '"]').html()
    popup.find('.js-load-content').html(content)
  }

  popup.attr('data-type', type)

  body.addClass('popup-open')
  $('html').addClass('popup-open')

  popup.show().addClass('opened')

  elementsToMaxHeight(popup.find('.company-url'))
  setupCursorEvent()

  loadElementLazyImage(popup.find('.lazy'))


  if (type === 'post') {
    setUrl($(clickedOn).data('url'))
  } else {
    setUrlHash(contentID)
  }

}

body.on('click', '.js-open-popup', function (e){
  e.preventDefault()
  openPopup($(this).attr('data-load-type'), $(this).attr('data-load-content-id'), this)

})

if(location.hash === '#winners') {
  openPopup('winners', 'winners', this)
}

if(location.hash === '#shortlist') {
  openPopup('shortlist', 'shortlist', this)
}

body.on('click', '.js-close-btn-popup', function (e){
  e.preventDefault()
  closePopup()
})
body.on('click', '.js-close-popup, .popup', function (e){
  if($(e.target).hasClass(".text-content") || $(e.target).closest(".text-content").length) return
  if($(e.target).hasClass(".post-popup-content") || $(e.target).closest(".post-popup-content").length) return
  if($(e.target).hasClass(".page-content") || $(e.target).closest(".page-content").length) return
  if($(e.target).hasClass(".shortlist-winner-content") || $(e.target).closest(".shortlist-winner-content").length) return

  closePopup()

})


$(document).keyup(function(e) {
  if (e.key === "Escape" && popup.is(':visible')) { // escape key maps to keycode `27`
    closePopup()
  }
});

body.on('click', '.js-shortlist-load-more', function (e){
  e.preventDefault()
  let $this = $(this)
  $('.popup.opened .shortlist-load-more .loader').addClass('visible')
  $this.hide()
  playLoadMoreAnimation()
  setTimeout(function (){
    $this.parent().fadeOut('fast', function (){
      $('.popup.opened .shortlist-load-more').remove()
      $('.popup.opened .shortlist-winner-content .category-row').removeClass('hidden')

    })
  }, 1000)

})


export function setUrlHash (hash) {
  if (lastHistory !== hash && !hashTimeout) {
    lastHistory = hash
    if (window.history && window.history.pushState) {
      let curUrl = window.location.href.split(/[?#]/)[0]
      if (hash) hash = '#' + hash
      history.pushState({}, null, curUrl + hash)
      hashTimeout = 1
      setTimeout(function(){hashTimeout = 0}, 300)
    }
  }
}

export function setUrl (url) {
  history.pushState({}, null, url)
}

export function setUrlParam (param, paramVal){
  let url = window.location.href
  var TheAnchor = null;
  var newAdditionalURL = "";
  var tempArray = url.split("?");
  var baseURL = tempArray[0];
  var additionalURL = tempArray[1];
  var temp = "";
  if (additionalURL) {
    var tmpAnchor = additionalURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor = tmpAnchor[1];
    if(TheAnchor)
      additionalURL = TheParams;
    tempArray = additionalURL.split("&");
    for (var i=0; i<tempArray.length; i++){
      if(tempArray[i].split('=')[0] != param){
        newAdditionalURL += temp + tempArray[i];
        temp = "&";
      }
    }
  }
  else{
    var tmpAnchor = baseURL.split("#");
    var TheParams = tmpAnchor[0];
    TheAnchor  = tmpAnchor[1];
    if(TheParams)
      baseURL = TheParams;
  }
  if(TheAnchor)
    paramVal += "#" + TheAnchor;
  var rows_txt = temp + "" + param + "=" + paramVal;

  window.history.replaceState('', '', (baseURL + "?" + newAdditionalURL + rows_txt) )
}



function goToHash (hash) {
  if (hash) {
    hash = hash.replace('#', '')
    hash = hash.replace('/', '')
    let hashEl = ''
    let isPopup = 0

    if (hash.search('popup-') !== -1){
        hashEl = hash
        isPopup = 1
    }

    if (hashEl.length) {
      if (isPopup){
        //openPopup('post', hashEl)
      } else {
        if (breakpointUp('lg')) {
          startLocoScroll()
          locoScroll.scrollTo(hashEl[0], { duration: 600, callback: updateLocoScroll })
        } else {
          $('html, body').animate({ scrollTop: hashEl.offset().top })
        }
      }
    }
    //setUrlHash(hash)
  }
}
